import { render, staticRenderFns } from "./userImage.vue?vue&type=template&id=4868d9c1&scoped=true"
import script from "./userImage.vue?vue&type=script&lang=js"
export * from "./userImage.vue?vue&type=script&lang=js"
import style0 from "./userImage.vue?vue&type=style&index=0&id=4868d9c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4868d9c1",
  null
  
)

export default component.exports